module.exports = __webpack_public_path__ + "static/media/city.b7b7c537.jpg";